// actions.js
import * as actionTypes from "./actionsTypes";

export const setValuePmes = (newValue) => ({
  type: actionTypes.SET_VALUE_PME,
  payload: newValue,
});

export const setCurrentPagePmes = (newCurrentPage) => ({
  type: actionTypes.SET_CURRENT_PAGE_PME,
  payload: newCurrentPage,
});

export const setSortingPmes = (newSorting) => ({
  type: actionTypes.SET_SORTING_PME,
  payload: newSorting,
});
export const setPageSizePmes = (newValue) => ({
  type: actionTypes.SET_PAGE_SIZE_PME,
  payload: newValue,
});

export const setCustomFilterPmes = (newValue) => ({
  type: actionTypes.SET_CUSTOM_FILTERS_PME,
  payload: newValue,
});
export const setSortFieldPmes = (newSortField) => ({
  type: actionTypes.SET_SORT_FIELD_PME,
  payload: newSortField,
});
export const setOrderPmes = (newOrder) => ({
  type: actionTypes.SET_ORDER_PME,
  payload: newOrder,
});
export const setActiveTabPmes = (newActiveTab) => ({
  type: actionTypes.SET_ACTIVE_TAB_PME,
  payload: newActiveTab,
});
export const setQueryPmes = (newQuery) => ({
  type: actionTypes.SET_QUERY_PME,
  payload: newQuery,
});
export const setActifPmes = (newQuery) => ({
  type: actionTypes.SET_ACTIF_PME,
  payload: newQuery,
});
export const setSelectedOptionFiltersPmes = (newQuery) => ({
  type: actionTypes.SET_SELECTED_OPTION_FILTERS_PME,
  payload: newQuery,
});
export const setSelectedOptionIdPmes = (newQuery) => ({
  type: actionTypes.SET_SELECTED_OPTION_ID_PME,
  payload: newQuery,
});

export const setColumnPmes = (newValue) => ({
  type: actionTypes.SET_COLUMN_PME,
  payload: newValue,
});
